import { tv, type VariantProps } from 'tailwind-variants';

const spinnerVariants = tv({
  base: 'animate-spin inline-block shrink-0',
  variants: {
    size: {
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      md: 'h-6 w-6',
      lg: 'h-8 w-8',
      xl: 'h-10 w-10'
    },
    color: {
      primary: 'text-blue-600',
      secondary: 'text-purple-600',
      destructive: 'text-red-600',
      warning: 'text-amber-600',
      neutral: 'text-slate-600'
    }
  },
  defaultVariants: {
    size: 'md',
    color: 'neutral'
  }
});

type SpinnerVariants = VariantProps<typeof spinnerVariants>;

interface SpinnerProps extends SpinnerVariants {
  label?: string;
  className?: string;
}

function Spinner({ size, color, label = 'Loading...', className }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} className="inline-flex">
      <svg
        className={spinnerVariants({ size, color, className })}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
    </span>
  );
}

export { Spinner, spinnerVariants, type SpinnerProps, type SpinnerVariants };
